var _path;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgTriagingFaceDown({
  title,
  titleId,
  ...props
}, svgRef) {
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 20,
    height: 17,
    viewBox: "0 0 20 17",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M9.7718 16.0569L0.443689 0.264199L19.0999 0.264201L9.7718 16.0569Z",
    fill: "#1B4880"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgTriagingFaceDown);
export default __webpack_public_path__ + "static/media/TriagingFaceDown.7e0fe408a9091d1ffccd412a89625381.svg";
export { ForwardRef as ReactComponent };